import { makeStyles, Theme, Grid } from "@material-ui/core";
import { useBaseStore, useUserStore } from "@roc/feature-app-core";
import { createCurrencyField, createDateField, CurrencyField, DateField } from "@roc/ui";
import { observer } from "mobx-react";
import ServicerProvidedDataStore from "../../stores/servicerProvidedDataStore";
import { usePayoffRequestStore } from "libs/feature-loans/src/loans/loanDetails/modules/loanRequests/hooks/usePayoffRequestStore";

const useStyles = makeStyles((theme: Theme) => ({
  formFields: {
    marginTop: '2rem',
  },
  recalculate: {
    marginTop: '2rem',
  },
  radioField: {
    paddingLeft: '10px',
  },
}));

interface Props {
  store: ServicerProvidedDataStore;
}

export const ServicerProvidedData = observer(({ store }: Props) => {
  const classes = useStyles();
  const formFields = store.form.fields;
  const { payoffRequestStore } = usePayoffRequestStore();
  const isForeclosure = payoffRequestStore.selectedPayoff?.foreclosure;

  return (
    <Grid container direction="row" justify="space-around">
      <Grid item xs={7} className={classes.formFields}>
        {createDateField({
          store,
          testId: 'expectedPayoffDate',
          label: isForeclosure ? 'Settlement Date' : 'Payoff Date',
          fieldName: 'expectedPayoffDate',
        })}
      </Grid>
      <Grid item xs={7} className={classes.formFields}>
        <CurrencyField
          standaloneLabel
          label={isForeclosure ? 'Settlement Amount Received' : 'Total Interest Received'}
          value={formFields.totalInterestReceived.value}
          variant="outlined"
          fullWidth
          testId="totalInterestReceived"
          onChange={(name, value) =>
            store.onFieldChange('totalInterestReceived', Number(value))
          }
        />
      </Grid>
      {!isForeclosure && (
        <>
          <Grid item xs={7} className={classes.formFields}>
            <CurrencyField
              standaloneLabel
              label="Total Proceeds"
              value={formFields.totalProceeds.value}
              variant="outlined"
              fullWidth
              testId="totalProceeds"
              onChange={(name, value) =>
                store.onFieldChange('totalProceeds', Number(value))
              }
            />
          </Grid>
          <Grid item xs={7} className={classes.formFields}>
            <CurrencyField
              standaloneLabel
              label="Refund To Borrower"
              value={formFields.refundToBorrower.value}
              variant="outlined"
              fullWidth
              testId="refundToBorrower"
              onChange={(name, value) =>
                store.onFieldChange('refundToBorrower', Number(value))
              }
            />
          </Grid>
        </>
      )}
    </Grid>
  );
});
